import React, { useContext } from 'react';
import GridColumnsContext from './GridColumnsContext';

const Detail = ({ title, value }) => (
  <div>
    <strong>{title}:</strong> {value}
  </div>
);

const RowDetails = ({ dataItem }) => {
  const columns = useContext(GridColumnsContext);
  return (
    <section>
      {columns
        .filter(({ isSystem }) => !isSystem)
        .map(({ title, field, renderDetail }) => (
          <Detail
            key={`col_${field}_row_${dataItem.id}`}
            title={title}
            value={renderDetail ? renderDetail({ dataItem }) : dataItem[field]}
          />
        ))}
    </section>
  );
};

export default RowDetails;
